import api from './api';

const actionItemService = {
  async getPriorities() {
    const res = await api.get('/Priority');
    return Array.isArray(res.data) ? res.data : [];
  },

  async getIssueCategories() {
    const res = await api.get('/IssueCategory');
    return Array.isArray(res.data) ? res.data : [];
  },

  /** @param {string} [studyProjectCode] Current study project code (required for study-scoped overdue list). */
  async getOverdueNotifications(studyProjectCode) {
    const code = (studyProjectCode || '').toString().trim();
    const params = code ? { projectCode: code } : {};
    const res = await api.get('/action-items/overdue-notifications', { params });
    return Array.isArray(res.data) ? res.data : [];
  },
};

export default actionItemService;
